/**
 * @generated SignedSource<<e0cbfbd2072d4a6dfb8f67500aba6189>>
 * @relayHash bd53976501ba51c900b81cf10540d7e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ecd0e878441a683b607181d140bd3bc87cf05e9a5f7026c3d3e75efc428a4188

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSpaceDetailQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useSpaceDetailQuery$data = {
  readonly space: {
    readonly alias: string | null | undefined;
    readonly dataClassificationTags: ReadonlyArray<string | null | undefined>;
    readonly homepage: {
      readonly id: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isDatabasesEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type useSpaceDetailQuery = {
  response: useSpaceDetailQuery$data;
  variables: useSpaceDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "alias"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "dataClassificationTags"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "title"
          },
          (v2/*: any*/)
        ]
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isLivePagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isWhiteboardsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isDatabasesEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceDetailQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceDetailQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bd53976501ba51c900b81cf10540d7e2",
    "id": "ecd0e878441a683b607181d140bd3bc87cf05e9a5f7026c3d3e75efc428a4188",
    "metadata": {},
    "name": "useSpaceDetailQuery",
    "operationKind": "query",
    "text": "query useSpaceDetailQuery($spaceKey:String){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}}}}"
  }
};
})();

(node as any).hash = "514317d5142523e30ff77dd356baa6e7";

export default node;
